import { render } from "./send-icon.svg.js?vue&type=template&id=1bf34d34!=!../../../../node_modules/rspack-vue-loader/dist/index.js??clonedRuleSet-12.use[0]!../../../../node_modules/vue-svg-loader-2/index.js??clonedRuleSet-12.use[1]!./send-icon.svg?vue&type=template&id=1bf34d34"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__